import 'bootstrap-sass/assets/javascripts/bootstrap/modal';
import 'picturefill/dist/picturefill';
import 'url-search-params-polyfill';
import '../../../../vendor/kunstmaan/cookie-bundle/Resources/ui/js';

import courses from './courses';
import hamburgers from './hamburgers';
import helpToggle from './helpToggle';
import landings from './landings';
import navigation from './navigation';
import observeFonts from './observeFonts';
import scrollAnimation from './scrollAnimation';
import search from './search';
import timer from './timer';
import categoryFilter from './categoryFilter';
import videoLink from './videoLink';
import './webfonts';

$(function() {
    courses();
    search();
    observeFonts();
    helpToggle();
    hamburgers();
    navigation();
    scrollAnimation();
    landings();
    timer();
    categoryFilter();
    videoLink();
});



// WEBPACK FOOTER //
// ./src/Resources/ui/js/app.js